export const mock = {
    walletAddress: '0xe5E613Ead611068bD2629365FBDdAD0472A4da0A',

    contractAddress: '0xAd2EB4808b817403005ae020B0662825eE021B0F',
    tokenId: '51',
    assetName: 'y00t#4512',
    collectionName: 'y00ts',
    thumbnail: 'https://metadata.y00ts.com/y/4512.png',

    floorPriceUsd: 6647.0,
    priceChange24h: 23.12,
    percentChange24h: 0.54321,

    bestOfferUsd: 7123.42,
};
